var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 14 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0H6V1.5H12V0ZM0 3V4.5H1.5V19.5C1.5 20.3284 2.17157 21 3 21H15C15.8284 21 16.5 20.3284 16.5 19.5V4.5H18V3H0ZM3 19.5V4.5H15V19.5H3ZM6 7.5H7.5V16.5H6V7.5ZM12 7.5H10.5V16.5H12V7.5Z",
    fill: "#E20074"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconsvg);
export default __webpack_public_path__ + "static/media/delete_icon.svg.c5928f896d2a60628a845b54a6b93b21.svg";
export { ForwardRef as ReactComponent };